
namespace TabAurous.Production {

    @Serenity.Decorators.registerClass()
    export class TreeMakingBOMDialog extends Serenity.EntityDialog<TreeMakingBOMRow, any> {
        protected getFormKey() { return TreeMakingBOMForm.formKey; }
        protected getIdProperty() { return TreeMakingBOMRow.idProperty; }
        protected getLocalTextPrefix() { return TreeMakingBOMRow.localTextPrefix; }
        protected getNameProperty() { return TreeMakingBOMRow.nameProperty; }
        protected getService() { return TreeMakingBOMService.baseUrl; }
        protected getDeletePermission() { return TreeMakingBOMRow.deletePermission; }
        protected getInsertPermission() { return TreeMakingBOMRow.insertPermission; }
        protected getUpdatePermission() { return TreeMakingBOMRow.updatePermission; }

        protected form = new TreeMakingBOMForm(this.idPrefix);

    }
}